import { Button, Table, TableColumnsType } from 'antd';
import { forwardRef } from 'react';
import useProfitPoolbyHierarchyDataInfiniteScroll from './hooks/useProfitPoolbyHierarchyDataInfiniteScroll';
import { calculateContainerHeight } from 'utils/helperMethods';

const ProfitPoolbyHierarchyTable = forwardRef<HTMLDivElement, {}>((props, ref) => {
    const tableHeight = calculateContainerHeight(3);

    const {
        tableData: profitPoolTableDataFinal,
        tableDefinition: profitPoolTableDefinition,
        min,
        max,
        isLoading,
        isSuccess,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    } = useProfitPoolbyHierarchyDataInfiniteScroll();

    return (
        <div ref={ref}>
            <Table
                columns={profitPoolTableDefinition}
                dataSource={profitPoolTableDataFinal}
                pagination={false}
                sticky={true}
                scroll={{ y: tableHeight }}
                loading={isLoading || isFetchingNextPage}
            />
            <div style={{ textAlign: 'center' }}>
                <Button
                    type="primary"
                    color="purple"
                    className="m-2"
                    onClick={() => fetchNextPage()}
                    disabled={isLoading || isFetchingNextPage || !hasNextPage}
                >
                    {isLoading || isFetchingNextPage ? 'Loading...' : 'Load More'}
                </Button>
            </div>
        </div>
    );
});
export default ProfitPoolbyHierarchyTable;
